import React from 'react'

import s from './styles.module.scss'

import { SimilarArticles } from './similar-articles'
import Button from '../../../../../components/atoms/fields/Button'
import { IconSvg } from '../../../../../components/atoms/icons'
import { cn } from '../../../../../shadcn/utils'

type ArticleFooterProps = {
  article: {
    pathname: string
  }
  similarArticles: Parameters<typeof SimilarArticles>[0]['articles']
}

export const ArticleFooter = ({
  similarArticles,
  article,
}: ArticleFooterProps) => {
  const url = process.env.NEXT_PUBLIC_APP_URL + '/blog/' + article.pathname
  return (
    <footer
      className={cn(
        s.articleFooter,
        'container mx-auto max-w-[1300px] px-[3vw]',
      )}
    >
      <div className={s.shareBtn}>Partager cet article sur </div>
      <div className={s.media}>
        <div className={s.logos}>
          {/* TODO: Use `Button` style with a simple <a> when possible */}
          <Button
            className={s.logoBtn}
            onClick={() =>
              window.open(
                `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
              )
            }
          >
            <IconSvg.Linkedin
              color='black'
              style={{ height: '12px', width: '12px' }}
            />
          </Button>

          {/* TODO: Use `Button` style with a simple <a> when possible */}
          <Button
            className={s.logoBtn}
            onClick={() =>
              window.open(`https://twitter.com/intent/tweet?url=${url}`)
            }
          >
            <IconSvg.Twitter
              color='black'
              style={{ height: '12px', width: '12px' }}
            />
          </Button>
        </div>
      </div>

      <SimilarArticles articles={similarArticles} />
    </footer>
  )
}
